import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import AppWrapper from './AppWrapper';
import reportWebVitals from './reportWebVitals';
import AppContext from './Config';
if (!window.location.hash || window.location.hash === '#/' || window.location.hash === '#') {
    window.location.replace('#/cotizacion');
}
const root = ReactDOM.createRoot(document.getElementById('root'));

//cuando vence sesion, redirigir a login
const originalFetch = window.fetch;
window.fetch = async (...args) => {
    const res = await originalFetch(...args);
    if (res && res.status === 401) {
        window.location.href = "https://sso.kesp.cl/sso/rest/login.htm";
    }
    return res;
};

root.render(
    <React.StrictMode>
        <AppContext>
            <HashRouter>
                <AppWrapper></AppWrapper>
            </HashRouter>  
        </AppContext>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
